export default __webpack_public_path__ + "static/kahl-ab2b77a41551510ee775bf906337a5f7.jpg";